<template>
  <div id="app">
    <n-config-provider
      :locale="zhCN"
      :theme="theme === 'light' ? lightTheme : darkTheme"
      :theme-overrides="themeOverrides"
    >
      <n-global-style />
      <n-dialog-provider>
        <n-message-provider>
          <router-view />
          <LoginModal v-if="loginStore.loginModalVisible" />
          <ChangePassword />
          <BindMobile />
          <RealNameReminder />
        </n-message-provider>
      </n-dialog-provider>
    </n-config-provider>
  </div>
</template>

<script setup lang="ts">
import LoginModal from '@/components/global/auth/LoginModal.vue'
import BindMobile from '@/components/global/bindMobile/index.vue'
import ChangePassword from '@/components/global/changePassword/index.vue'
import RealNameReminder from '@/components/global/realNameReminder/index.vue'
import useLoginStore from '@/store/login/login'
import { createMockLoginStorageSync } from '@/store/login/mock-login-storage-sync'
import { theme } from '@/utils/naive-instance'
import {
  darkTheme,
  lightTheme,
  NConfigProvider,
  NGlobalStyle,
  zhCN
} from 'naive-ui'
import { onBeforeUnmount, onMounted } from 'vue'

const loginStore = useLoginStore()
const mockLoginStorageSync = createMockLoginStorageSync(() => {
  window.location.reload()
})

onMounted(() => {
  window.addEventListener('storage', mockLoginStorageSync.handleStorage)
})

onBeforeUnmount(() => {
  window.removeEventListener('storage', mockLoginStorageSync.handleStorage)
  mockLoginStorageSync.dispose()
})

const themeOverrides = {
  common: {
    primaryColor: '#2678FF',
    primaryColorHover: '#1967E5',
    primaryColorPressed: '#0F56C9',
    primaryColorSuppl: '#3B86FF',
    successColor: '#47C93A',
    successColorHover: '#3CB830',
    warningColor: '#FF7D00',
    warningColorHover: '#E67000',
    errorColor: '#F53F3F',
    errorColorHover: '#E03838',
    infoColor: '#86909C',
    borderRadius: '4px',
    fontFamily: "'PingFang SC', 'Microsoft YaHei', sans-serif"
  },
  Dropdown: {
    optionTextColor: '#1e1e1e',
    optionBgColor: '#fff',
    optionHoverTextColor: '#2678FF',
    optionHoverBgColor: '#E6F7FF',
    optionActiveTextColor: '#2678FF',
    optionActiveBgColor: '#E6F7FF'
  },
  Button: {
    textColor: '#1e1e1e',
    hoverTextColor: '#2678FF',
    primaryTextColor: '#fff'
  }
}
</script>

<style lang="scss" scoped>
#app {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #f4f4f4;
}
</style>
<style lang="scss">
@use '@/styles/index';
@use 'sass:map';
:root {
  --n-primary-color: #2678ff;
  --n-primary-color-hover: #1967e5;
  --n-error-color: #f53f3f;
}
</style>
